import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../../../utils/colors';

export const CardList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const CountBadge = styled(Box)({
  minWidth: 18,
  height: 18,
  padding: '0 5px',
  borderRadius: 9,
  backgroundColor: ultraMarine[500],
  color: 'white',
  fontSize: 11,
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const EmptyState = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '0 40px',
  textAlign: 'center',

  '& > .dot': {
    width: 34,
    height: 34,
    borderRadius: '50%',
    border: `2px solid ${ultraMarine[300]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,

    '&::after': {
      content: '""',
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: ultraMarine[400],
    },
  },

  '& .MuiTypography-root': {
    color: spaceCadet[400],
  },
});
